const DeclarationConfidentielleCheckboxLabel =
  "Je souhaite que ma déclaration soit confidentielle (lien avec les Risques Psycho Sociaux, Harcèlement, Signaux faibles, ...), à ce titre qu'elle soit diffusée au strict minimum de destinataires (Secrétaires généraux des organisations syndicales, Responsables Ressources Humaines, Pôle Santé Sécurité au Travail et Gestion des Temps).";

export default DeclarationConfidentielleCheckboxLabel;
